// Dynamic, subtle animated background for the hero: gradient mesh blobs +
// digital grid + soft data nodes/connection lines. Respects prefers-reduced-motion.
export function HeroBackground() {
  const nodes = [
    { x: 12, y: 22 }, { x: 30, y: 62 }, { x: 48, y: 30 },
    { x: 68, y: 66 }, { x: 84, y: 28 }, { x: 60, y: 14 }, { x: 90, y: 58 },
  ];
  const links = [[0, 1], [1, 2], [2, 5], [2, 3], [3, 4], [4, 6], [3, 6], [5, 4]];
  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="grid-overlay absolute inset-0 opacity-70" />
      <div className="mesh-blob animate-blob" style={{ width: 520, height: 520, background: "#0E7490", top: -120, left: -80 }} />
      <div className="mesh-blob animate-blob" style={{ width: 460, height: 460, background: "#06B6D4", top: 40, right: -120, animationDelay: "-6s" }} />
      <div className="mesh-blob animate-blob" style={{ width: 380, height: 380, background: "#0D9488", bottom: -140, left: "35%", animationDelay: "-11s" }} />
      <svg className="absolute inset-0 h-full w-full" preserveAspectRatio="none" viewBox="0 0 100 100">
        {links.map(([a, b], i) => (
          <line key={i} x1={nodes[a].x} y1={nodes[a].y} x2={nodes[b].x} y2={nodes[b].y}
            stroke="rgba(34,211,238,0.18)" strokeWidth="0.15" />
        ))}
        {nodes.map((n, i) => (
          <g key={i} className="dot-node" style={{ transformOrigin: `${n.x}px ${n.y}px`, animationDelay: `${-i}s` }}>
            <circle cx={n.x} cy={n.y} r="0.9" fill="#22D3EE" opacity="0.5" />
            <circle cx={n.x} cy={n.y} r="0.4" fill="#ffffff" opacity="0.8" />
          </g>
        ))}
      </svg>
      <div className="absolute inset-0" style={{ background: "radial-gradient(120% 90% at 50% -10%, rgba(6,182,212,0.10), transparent 60%)" }} />
    </div>
  );
}
